import * as React from 'react';
import { Skeleton } from '@ghq-abi/design-system-v2';

import { Avatar } from '~/shared/components/Avatar';
import { cn } from '~/shared/utils/cn';

type EmployeeProfileResumeProps = {
  employeeId?: string;
  globalId?: string;
  firstName?: string;
  lastName?: string;
  position?: string;
  isLoading?: boolean;
  className?: string;
};

// TODO: Adjust to use on manager assessment user profile too

export function EmployeeProfileResume({
  employeeId,
  globalId,
  firstName,
  lastName,
  position,
  isLoading,
  className,
}: EmployeeProfileResumeProps) {
  const name = firstName && lastName ? `${firstName} ${lastName}` : '';

  return (
    <div className={cn('flex items-center justify-start gap-2', className)}>
      <div className="hidden lg:block">
        {!isLoading && globalId && (
          <Avatar
            size="md"
            name={name}
            employeeId={employeeId}
            globalId={globalId}
            key={employeeId}
          />
        )}
        {isLoading && <Skeleton className="h-10 w-10 rounded-full" />}
      </div>

      {isLoading && (
        <>
          <div className="flex items-center gap-2">
            <Skeleton className="h-7 w-5" />
            <Skeleton className="h-7 w-5" />
          </div>

          <div className="flex flex-col items-start justify-start gap-2">
            <Skeleton className="h-[22px] w-[180px]" />
            <Skeleton className="h-4 w-[90px]" />
          </div>
        </>
      )}

      {!isLoading && (
        <div className="ml-2.5 flex flex-col items-start justify-start gap-1">
          <h3 className="text-base font-semibold uppercase leading-5">
            {firstName && lastName ? (
              <>
                {firstName} {lastName}
              </>
            ) : (
              name
            )}
          </h3>
          {position && (
            <span className="mt-2 block text-sm font-normal leading-5 text-[#2E2C34]">
              {position}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
